import React from 'react';
import PropTypes from 'prop-types';
import * as generalFunctions from '../../common/utils/generalFunctions';

const getDisplayValue = (...values) => {
  for (let i = 0; i < values.length; i++) {
    if (values[i] !== null && typeof values[i] !== 'undefined' && values[i] !== '') {
      return values[i];
    }
  }

  return '';
};

const getFormattedDateValue = (...values) => {
  const value = getDisplayValue(...values);

  if (!value) {
    return '';
  }

  return generalFunctions.getFormattedDisplayDate(value, false, true);
};

const isMinDateValue = (value) => {
  if (!value) {
    return false;
  }

  const textValue = value.toString();
  return textValue.startsWith('0001-01-01') || textValue.startsWith('1/1/0001');
};

const DraftOrdersRow = (props) => {
  const row = props.data || {};
  const cellClass = {};

  if (props.headers) {
    for (let i = 0; i < props.headers.length; i++) {
      cellClass[i] = {className: props.headers[i].className};
    }
  }

  const handleRowClick = () => {
    if (props.callback) {
      props.callback(row);
    }
  };

  return (
    <tr onClick={handleRowClick} style={{ cursor: 'pointer' }}>
      <td {...cellClass[0]}>{getDisplayValue(row.headerId)}</td>
      <td {...cellClass[1]}>{getFormattedDateValue(row.deliveryDateDisplay, row.deliveryDate)}</td>
      <td {...cellClass[2]}>{getDisplayValue(row.serverOrderCutoffDateTimeDisplay, row.serverOrderCutoffDateTime)}</td>
      <td {...cellClass[3]}>{typeof row.total === 'number' ? row.total.toFixed(2) : getDisplayValue(row.total)}</td>
      <td {...cellClass[4]}>{getDisplayValue(row.lineCount)}</td>
      <td {...cellClass[5]}>{getFormattedDateValue(row.createDate)}</td>
      <td {...cellClass[6]}>{getDisplayValue(row.createdBy)}</td>
      <td {...cellClass[7]}>{isMinDateValue(row.modifiedDate) ? '' : getFormattedDateValue(row.modifiedDate)}</td>
      <td {...cellClass[8]}>{getDisplayValue(row.modifiedBy)}</td>
      <td {...cellClass[9]}>{getDisplayValue(row.purchaseOrderNumber)}</td>
      <td {...cellClass[10]}>{getDisplayValue(row.invoiceNumber)}</td>
      <td {...cellClass[11]}>{getDisplayValue(row.orderNote)}</td>
    </tr>
  );
};

DraftOrdersRow.propTypes = {
  data: PropTypes.object,
  headers: PropTypes.array,
  callback: PropTypes.func
};

export default DraftOrdersRow;
